import React from 'react';
import { styled, css } from 'styled-components';
import SvgChevron from '../../../../play-core/icons/Chevron';
import { Device } from '../../../../play-core/styles/Device';
import { Shadows } from '../../../../play-core/styles/Shadows';
import { zIndex } from '../../../../play-core/styles/z-index';
import { jsx as _jsx } from "react/jsx-runtime";
const buttonSize = 40;
export const SwipeableButton = ({
  direction,
  spacing,
  top,
  isActive = true,
  ...props
}) => /*#__PURE__*/_jsx(Container, {
  isActive: !!isActive,
  style: {
    right: direction === 'right' ? `${spacing}px` : 'auto',
    left: direction === 'left' ? `${spacing}px` : 'auto',
    top: top ? `${top - buttonSize / 2}px` : 'auto',
    height: top ? 'auto' : '100%'
  },
  children: /*#__PURE__*/_jsx(Button, {
    ...props,
    "aria-hidden": "true",
    "aria-label": `Scroll ${direction}`,
    children: /*#__PURE__*/_jsx(ButtonLayout, {
      children: /*#__PURE__*/_jsx(SvgChevron, {
        orientation: direction
      })
    })
  })
});
export const containerStyle = (isActive = true) => css(["display:flex;align-items:center;width:40px;position:absolute;z-index:", ";transition:opacity 200ms ease-in-out;", "{display:none;}", ""], zIndex.popup, Device.touch, !isActive && css(["opacity:0.65;"]));
export const Container = styled.div.withConfig({
  displayName: "SwipeableButton__Container",
  componentId: "sc-j2jjy0-0"
})(["", ""], ({
  isActive = true
}) => containerStyle(isActive));
const Button = styled.button.withConfig({
  displayName: "SwipeableButton__Button",
  componentId: "sc-j2jjy0-1"
})(["height:", "px;width:", "px;border-radius:50%;background-color:#fafafa;", ";&:hover{", ";background-color:#fff;}"], buttonSize, buttonSize, Shadows.applyDouble(8), Shadows.applyDouble(16));
const ButtonLayout = styled.div.withConfig({
  displayName: "SwipeableButton__ButtonLayout",
  componentId: "sc-j2jjy0-2"
})(["display:flex;justify-content:center;align-items:center;height:40px;width:40px;color:#000000;font-size:16px;transition:all 0.2s ease-in-out;"]);